import HeaderCom from '@/components/header/header.vue';
import OcrIdentify from './ocr-identify/index.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    HeaderCom,
    OcrIdentify
  },
  data() {
    return {
    };
  },
  computed: mapGetters([
    'ocrBoxInfo'
  ]),
  created() {
  },
  methods: {
  }
};
